import React, { Component } from 'react'
import FormViewer from './FormViewer'
import { nanoid } from 'nanoid'
import HttpServices from '../utils/Http.services'
import { checkTranslation, translate } from '../utils/useful'
import ItemModal from '../modals/ItemModal'
import ButtonAnimated from './buttons/ButtonAnimated'

export default class FieldsData extends Component {

    state = {
        // initData: {}
    }

    componentDidMount() {
        // console.log('this.props.initData22', this.props?.field)
        // console.log('this.props.initData', this.props.initData.appletHub)
        // let initData = this.state.initData
        // initData.appletId = this.props.initData.applet
        // initData.appletHub = this.props.initData.appletHub
        // this.setState({ initData })
    }
    getForm = () => {
        // console.log('this.form.getForm()', form)
        // console.log('this.props.field.type', this.props.field)
        // if (this.props.field.type == 'LookupInput') {

        // }
        // return
        // console.log('this.form.getForm()',this.form.getForm())
        // return
        return this.form.getForm()

    }

    open = () => {
        this.itemModal.open()
    }


    close = () => {
        this.itemModal.close()
    }
    liveChange = (data) => {
        // console.log('datassss', data)
    }
    render() {
        return (
            <div>

                {/* <ItemModal
                    ref={el => this.itemModal = el}
                    page={this.props.page}
                    headers={this.props?.field?.headers}
                    pages={this.props.formPages}

                    initData={this.props.initData}
                    variables={this.props.variables}
                    itemAdded={this.itemAdded}
                    itemEdited={this.itemEdited}
                    width={this.props.width}
                    sideOpen={true}
                    // showDates={true}
                    submitForm={this.addField}
                    // functionsHandler={this.functionsHandler}
                    widthImport={300}
                // background={'linear-gradient(to right, rgb(77,46,229), rgb(77,46,229))'}
                // color={"rgb(77,46,229)"}
                /> */}


                <div className=''>
                    <div className='h-100 pb-5'>
                        {/* <div className='px-3  flexc py-3' style={{background:this.props.colors?.background}}>
                            <div className='br-4 ' style={{}}>
                                <p className='font-size-14 weight-500 ' style={{color:this.props.colors?.textColor }}>{translate("Field Type")} - {checkTranslation(this.props.field?.label)}</p>
                            </div>
                        </div> */}
                        {/* {this.props.deleteHeader && (
                            <div className=' py-2 px-3 position-sticky' style={{ background: this.props.colors?.background, top: 0, zIndex: 10 }}>
                                <p className='main-c2 font-size-16 weight-500' style={{ color: this.props.colors?.textColor }}>{translate('Are you sure you want to delete?')}</p>
                            </div>
                        )} */}
                        <div className='mt-3'>
                            <FormViewer ref={el => this.form = el} liveChange={this.liveChange} headers={this.props?.field?.headers} formClass={'bordered-form'} inputClass={'bordered-input'} />
                        </div>
                    </div>
                    <div className='flexc w-100 px-2 py-2 position-sticky bg-white' style={{ justifyContent: 'flex-end', bottom: 0 }}>
                        {/* <div className='px-2'>
                            <ButtonAnimated
                                // iconwidth='24px'
                                onClick={() => { this.props.closeFieldsData() }}
                                title={translate('Cancel')}
                                // icon='/assets/icons/plus-white.svg'
                                textColor={'#777'}
                                invert={!this.props.colors?.iconInvert}
                                bg={'#eee'}
                            // isLoading={this.state.isLoading}
                            />
                        </div> */}
                        {this.props.deleteHeader && (
                            <ButtonAnimated
                                // iconwidth='24px'
                                // onClick={() => { !this.state.isLoading && this.addField() }}
                                title={translate('Delete')}
                                // icon='/assets/icons/plus-white.svg'
                                textColor={this.props.colors?.textColor}
                                invert={!this.props.colors?.iconInvert}
                                bg={this.props.colors?.background}
                                isLoading={this.state.isLoading}
                            />
                        )}
                        {this.props.editHeader && (
                            <ButtonAnimated
                                iconwidth='24px'
                                // onClick={() => { !this.state.isLoading && this.addField() }}
                                title={translate('Submit')}
                                icon='/assets/icons/arrow-right-white.svg'
                                textColor={this.props.colors?.textColor}
                                invert={!this.props.colors?.iconInvert}
                                bg={this.props.colors?.background}
                                isLoading={this.state.isLoading}
                            />
                        )}
                    </div>
                    {/* <div className='flexc  py-2 w-100' style={{ position: "fixed", bottom: 0, zIndex: 10 }}>
                        <button className='gray-btn w-100 mx-2 py-2 br-5'>
                            <p className='main-c5'>{translate('Discard')}</p>
                        </button>
                        <button className='purple-btn w-100 mx-2 py-2 br-5' onClick={() => this.addField()}>
                            <p>{translate('Submit')}</p>
                        </button>
                    </div> */}
                </div>
            </div>
        )
    }
}
